
export enum DeviceState {
  Unknown = 'Unknown',
  Unmanaged = 'Unmanaged',
  Unavailable = 'Unavailable',
  Disconnected = 'Disconnected',
  Prepare = 'Prepare',
  Config = 'Config',
  NeedAuth = 'NeedAuth',
  IpConfig = 'IpConfig',
  IpCheck = 'IpCheck',
  Secondaries = 'Secondaries',
  Activated = 'Activated',
  Deactivating = 'Deactivating',
  Failed = 'Failed',
}

export const DeviceStateColor: Map<DeviceState, string> = new Map([
  [DeviceState.Unknown, 'gray'],
  [DeviceState.Unmanaged, 'gray'],
  [DeviceState.Unavailable, 'gray'],
  [DeviceState.Disconnected, 'warning'],
  [DeviceState.Prepare, 'blue'],
  [DeviceState.Config, 'blue'],
  [DeviceState.NeedAuth, 'warning'],
  [DeviceState.IpConfig, 'blue'],
  [DeviceState.IpCheck, 'blue'],
  [DeviceState.Secondaries, ''],
  [DeviceState.Activated, 'success'],
  [DeviceState.Deactivating, 'blue'],
  [DeviceState.Failed, 'error'],
]);
